export interface MediaSessionPlugin {
  setMetadata(options: {
    title?: string;
    artist?: string;
    album?: string;
    artwork?: Array<{
      src: string;
      sizes?: string;
      type?: string;
    }>;
  }): Promise<void>;

  setPlaybackState(options: {
    playbackState: 'none' | 'playing' | 'paused';
  }): Promise<void>;

  setPositionState(options: {
    duration?: number;
    position?: number;
    playbackRate?: number;
  }): Promise<void>;

  setActionHandler(options: {
    action: 'previoustrack' | 'seekbackward' | 'play' | 'pause' | 'seekforward' | 'nexttrack' | 'seekto' | 'stop';
  }): Promise<void>;
}
